import { render, staticRenderFns } from "./AnnouncementModalForm.vue?vue&type=template&id=2b6acba8&"
import script from "./AnnouncementModalForm.vue?vue&type=script&lang=js&"
export * from "./AnnouncementModalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports